import { getGA } from 'analytics/GoogleAnalytics';
import { PERFORMANCE_CATEGORY } from '../../utils/deviceDetection';

export default class OnboardingController {
  constructor(game, campout) {
    this.game = game;
    this.campout = campout;

    this.step = 0;
    this.completed = campout.savedData.onboarding_completed;
  }

  start() {
    if (!this.completed) {
      getGA().track({ action: 'tutorial_begin' });
      this.game.time.events.add(100, this.step1, this);

      this.campout.gameHud.lockArrows();
      this.campout.gameHud.hideScrollArrows();
    }
  }

  step1() {
    this.step = 1;
    this.campout.gameHud.lock();
    this.campout.location.disableControls();
    if (this.game.deviceMetric.category === PERFORMANCE_CATEGORY.HIGH_END) {
      // modern device
      this.campout.camera.pan(3150);
      this.campout.camera.onPosition.addOnce(this.step2, this);
    } else {
      // old device
      this.step2();
    }
    this.game.controller.playVO(
      'onboarding_hint_001' + (this.game.deviceMetric.platform.type === 'desktop' ? '_click' : '')
    );
  }

  step2() {
    // wait on interaction
    this.step = 2;
    this.campout.camera.pan(2650);

    this.timeEvent = this.game.time.events.add(5000 + 3000, this.step3, this);
  }

  step3() {
    // drag tutorial
    this.step = 3;
    this.campout.location.enableControls();
    this.campout.gameHud.showDragHint(false);
    this.game.controller.stopVO();
    this.game.controller.playVO('onboarding_hint_002');

    this.timeEvent = this.game.time.events.add(3600 + 5000, this.step4, this);
  }

  step4() {
    // return to camp area
    this.step = 4;
    this.campout.location.disableControls();
    this.campout.camera.pan(2650);
    this.campout.camera.onPosition.addOnce(this.step5, this);
    this.game.controller.stopVO();
    this.game.controller.playVO('onboarding_hint_004');

    console.log('camX: ' + this.campout.camera.currentX);
    if (this.campout.camera.currentX === 2650) {
      this.step5();
    }
  }

  step5() {
    // tents part start
    this.step = 5;
    this.campout.location.enableControls();
    this.game.time.events.add(2000, this.campout.location.pulseTents, this.campout.location);

    this.timeEvent = this.game.time.events.add(5400, this.step6, this);
  }

  step6() {
    // wait on open tent
    this.step = 6;
    this.timeEvent = this.game.time.events.add(3000, this.step7, this);
  }

  step7() {
    // pulse help button
    this.step = 7;
    this.game.controller.stopVO();
    this.game.controller.playVO('onboarding_hint_003');
    this.campout.gameHud.btnHelp.pulse(3500);
    this.game.time.events.add(3500, this.step8, this);
  }

  step8() {
    // finish onboarding
    this.campout.gameHud.unlock();

    this.campout.gameHud.unlockArrows();
    this.campout.gameHud.unhideScrollArrows();
    this.campout.setArrowsVisibility();

    this.completed = true;

    // save
    this.campout.savedData.onboarding_completed = true;
    this.game.controller.saves.save({ data: this.campout.savedData });

    getGA().track({ action: 'tutorial_complete' });
  }

  interacted(object) {
    console.log('interacted');
    if (this.step === 2) {
      this.game.time.events.remove(this.timeEvent);
      this.step3();
    } else if (this.step === 5 || this.step === 6) {
      if (
        object.id === 'tent_1_rolled' ||
        object.id === 'tent_2_rolled' ||
        object.id === 'tent_3_rolled'
      ) {
        this.game.time.events.remove(this.timeEvent);
        this.step7();
      }
    }
  }

  scrolled() {
    console.log('scrolled');
    if (this.step === 3) {
      this.game.time.events.remove(this.timeEvent);
      this.campout.gameHud.removeDragHint();

      this.step = -1;
      this.game.time.events.add(1000, this.step4, this);
    }
  }
}
